import { AxiosResponse } from "axios";
import aiApi from "../api/ai.api";
import businessPortalClient from "../businessPortalClient";

type AiService = {
  getConnectionString: () => Promise<AxiosResponse<string>>;
};

const getConnectionString = (): Promise<AxiosResponse<string>> =>
  businessPortalClient.get(aiApi.getConnectionStringUrl());

export default {
  getConnectionString,
} as AiService;
